import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import ForumNameSchema, { ForumNameJSON, ForumNameParams } from "notifications/message-notifications/forum-info/forum-name-schema";

export default class ForumName {
  public static fromJSON(json: unknown): ForumName | null | undefined {
    if (isNullOrUndefined(json)) return json;
    const parsed = ForumNameSchema.deserialize(json);
    return new ForumName(parsed);
  }
  public constructor(public readonly value: ForumNameParams) {
    this.value = ForumNameSchema.validateParams(value);
  }

  public isEqualTo(other: ForumName): boolean {
    return this.value === other?.value;
  }

  public toString(): string {
    return this.value.toString();
  }

  public toJSON(): ForumNameJSON {
    return this.value;
  }
}
